import { createStyles } from "@mantine/emotion";

import { rooterMediaQuery } from "_styles/theme/mediaQuery";

export default createStyles ( ( theme, props ) => ( {
	mainContainer: {
		display: "flex"
	},
	playerBodyContainer: {
		padding : props?.theatreModeToggle ? "0" : "2rem",
		height  : props?.theatreModeToggle ? "100vh" : "",
		width   : "100%",

		[rooterMediaQuery.mobile]: {
			padding: "unset"
		}
	},
	container: {
		margin: "2rem 0 0 0.5rem"
	},
	theatreModeOn: {
		display  : "flex",
		position : "fixed",
		zIndex   : "1200",
		top      : "0",
		left     : "0",
		width    : "100%",
		height   : "100%"
	},
	theatreModeOnChatPop: {
		position : "fixed",
		zIndex   : "1200",
		top      : "0",
		left     : "0",
		width    : "100%",
		height   : "100%"
	},
	theatreModeOff: {
		margin  : "2rem",
		display : "flex"
	},
	cardWrapper: {
		margin: "0 1rem"
	}
} ) );

